import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetSiteStagingResponseJSON, PushLiveOptions, SiteStaging, StagingStatus } from './staging';
import { JobsResponseJSON } from '../job/job';
import { Job } from '../job';

const SITE_URL_V1 = '/api/v1/site/';
const SITE_URL_V2 = '/api/v2/site/';

@Injectable()
export class StagingApiService {
  private headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient) {}

  httpGetStagingStatus(siteId: string): Observable<StagingStatus> {
    const url = `${SITE_URL_V2}${siteId}/staging/`;
    return this.http.get(url).pipe(map((res: GetSiteStagingResponseJSON) => SiteStaging.fromJSON(res.data).staging));
  }

  httpLookupLatestJob(
    siteId: string,
    jobType: string,
    pageSize: number,
    cursor: string = null,
  ): Observable<Job | null> {
    const params = {
      job_type: jobType,
      page_size: pageSize.toString(),
    };
    if (cursor) {
      params['cursor_string'] = cursor;
    }
    const httpParams = new HttpParams({ fromObject: params });
    const url = `${SITE_URL_V1}${siteId}/job`;
    return this.http
      .get(url, { params: httpParams })
      .pipe(map((res: JobsResponseJSON) => (res.data.jobs[0] ? Job.fromApi(res.data.jobs[0]) : null)));
  }

  httpPostCreateStaging(siteId: string): Observable<any> {
    const url = `${SITE_URL_V2}${siteId}/staging/create/`;
    return this.http.post(url, {}, { headers: this.headers });
  }

  httpPostResetStaging(siteId: string): Observable<any> {
    const url = `${SITE_URL_V2}${siteId}/staging/reset/`;
    return this.http.post(url, {}, { headers: this.headers });
  }

  httpPostResetStagingFromTemplate(siteId: string, templateId: string): Observable<any> {
    const url = `${SITE_URL_V2}${siteId}/staging/reset_template/`;
    return this.http.post(url, { template_id: templateId }, { headers: this.headers });
  }

  httpPostPushStaging(request: PushLiveOptions, siteId: string): Observable<any> {
    const url = `${SITE_URL_V2}${siteId}/staging/push/`;
    const site_components: string[] = [];
    if (request.siteComponents === 'FILESYSTEM_DB') {
      site_components.push('filesystem', 'db');
    } else {
      site_components.push('filesystem');
    }
    const body = {
      site_components: site_components,
      preserve: request.preserveStaging,
    };
    return this.http.post(url, JSON.stringify(body), { headers: this.headers });
  }
}
